import { render, staticRenderFns } from "./PopularTagList.vue?vue&type=template&id=57efa738&"
import script from "./PopularTagList.vue?vue&type=script&lang=ts&"
export * from "./PopularTagList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports